export const getFileExtension = fileName => {
  if (!fileName) return "";
  const matchResult = fileName.match(/\.([^.]+)$/);

  if (!matchResult || matchResult.length !== 2) return "";

  return matchResult[1];
};
